import { useEffect, useState } from "react";
import { api } from "@/lib/auth";
import { Trophy, Loader2 } from "lucide-react";

const money = (cents) => `$${((cents || 0) / 100).toLocaleString("en-AU", { maximumFractionDigits: 0 })}`;

export default function ReferralLeaderboard() {
    const [rows, setRows] = useState(null);
    const [err, setErr] = useState(null);

    useEffect(() => {
        api.get("/reports/referral-leaderboard")
            .then(({ data }) => setRows(data.rows || []))
            .catch(() => setErr("Could not load the referral leaderboard."));
    }, []);

    return (
        <section className="mt-10" data-testid="referral-leaderboard">
            <div className="flex items-center gap-2 mb-4">
                <Trophy size={14} className="text-[#FF5A00]" />
                <span className="font-mono-tech text-[11px] uppercase tracking-[0.35em] text-slate-400">/ Referral leaderboard</span>
            </div>
            {err ? (
                <div className="border border-[#FF5A00]/40 p-4 text-xs text-slate-400" data-testid="referral-leaderboard-error">{err}</div>
            ) : rows === null ? (
                <div className="flex items-center gap-2 text-xs text-slate-400 py-4">
                    <Loader2 size={13} className="animate-spin text-[#FF5A00]" /> Loading…
                </div>
            ) : rows.length === 0 ? (
                <div className="border border-white/10 p-5 text-xs text-slate-400" data-testid="referral-leaderboard-empty">
                    No referred revenue yet — it will appear here as soon as a referral code is used at checkout.
                </div>
            ) : (
                <div className="border border-white/10 overflow-x-auto">
                    <table className="w-full text-sm" data-testid="referral-leaderboard-table">
                        <thead>
                            <tr className="border-b border-white/10 text-left">
                                {["#", "Client", "Code", "Campaigns", "Referred revenue", "Credits earned"].map((h) => (
                                    <th key={h} className="px-4 py-3 text-[10px] font-mono-tech uppercase tracking-[0.25em] text-slate-500 font-normal whitespace-nowrap">{h}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((r, i) => (
                                <tr key={r.code} className="border-b border-white/5 last:border-b-0 hover:bg-white/[0.02]" data-testid={`leaderboard-row-${r.code}`}>
                                    <td className="px-4 py-3 font-display font-black text-[#FF5A00]">{i + 1}</td>
                                    <td className="px-4 py-3">
                                        <div className="text-white text-sm">{r.referrer_name}</div>
                                        {r.referrer_email && <div className="text-[10px] font-mono-tech text-slate-500">{r.referrer_email}</div>}
                                    </td>
                                    <td className="px-4 py-3 font-mono-tech text-xs text-slate-300">{r.code}</td>
                                    <td className="px-4 py-3 text-slate-300">{r.campaigns}</td>
                                    <td className="px-4 py-3 text-white font-medium" data-testid={`leaderboard-revenue-${r.code}`}>{money(r.revenue_cents)}</td>
                                    <td className="px-4 py-3 text-emerald-300">{money(r.credits_earned_cents)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </section>
    );
}
